import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "23",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      d: "M23.503 11.312 12.6.252A.85.85 0 0 0 12 0a.84.84 0 0 0-.599.252L.498 11.312c-.318.322-.498.76-.498 1.217 0 .948.76 1.72 1.694 1.72h1.15v7.891c0 .476.378.86.846.86h6.616v-6.019h2.965V23h7.04a.853.853 0 0 0 .847-.86v-7.892h1.149c.45 0 .881-.18 1.199-.505a1.74 1.74 0 0 0-.003-2.431"
    }, null, -1)
  ])))
}
export default { render: render }